module.exports = __webpack_public_path__ + "static/trash-disabled.486a1fcfd62ac0f9a72cf96b2c083642.svg";